module.exports = __webpack_public_path__ + "media/images/OPL EXPRESS 3-475173c016853f710858173578dfc61e.png";